module.exports = __webpack_public_path__ + "img/ep-feuille.38ff2fe6.jpg";